export default __webpack_public_path__ + "static/media/Bankingblack.aa0ad5f7.svg";